import { useRouter } from 'next/router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { trackMixpanelEvent } from 'utils/analytics';

import { Button, Typography } from '@/shared/components/atoms';
import routes from '@/shared/constant/routes';
import { useAuth } from '@/shared/hooks/context/auth';

function FloatingSubscriptionCard() {
  const { user } = useAuth();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';
  const { push } = useRouter();
  const [showCard, setShowCard] = useState(true);
  const { pathname } = useRouter();

  if (!showCard) return null;

  return (
    <div
      className='flex flex-col items-center justify-center gap-y-24 p-20 pt-36'
      style={{
        background: 'linear-gradient(135deg, #1073E1 0%, #0953A5 100%)',
        borderRadius: '24px',
        width: '100%',
        maxWidth: '460px',
        position: 'fixed',
        bottom: '24px',
        right: isRTL ? 'unset' : '24px',
        left: isRTL ? '24px' : 'unset',
        zIndex: '20',
      }}
    >
      <Typography
        variant='h2'
        className='text-center'
        style={{ color: 'white' }}
      >
        {t('subscribe-promo-card', { promo: '$100', code: 'SAVE100' })}
      </Typography>
      <Typography
        variant='body1'
        className='text-center'
        style={{ color: 'white' }}
      >
        {pathname === routes.subscription
          ? t('apply-discount-code')
          : t('subscribe-promo-card-description')}
      </Typography>

      <div className='mt-16 flex w-full items-center justify-end'>
        <Button
          variant='text'
          onClick={() => {
            setShowCard(false);
            trackMixpanelEvent('Promo code closed', user);
          }}
        >
          <Typography variant='body1' className='text-center text-white'>
            {t('close')}
          </Typography>
        </Button>
        <Button
          color='secondary'
          onClick={() => {
            push(routes.subscription);
            trackMixpanelEvent('Promo code CTR', user);
          }}
        >
          {t('promo-cta', { saving: '$100' })}
        </Button>
      </div>
    </div>
  );
}

export default FloatingSubscriptionCard;
